// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"1b8f53e3","977":"fb55a997"}[chunkId] + ".chunk.js";
};